/*
 * LB Busca inteligente (Lui Bambini)
 *
 * A busca do Shopify, quando acha pouco, "afrouxa" e mistura produtos com só uma das
 * palavras ("manga" traz manga curta) e corta resultados por relevância. Para quem
 * procura uma categoria, a coleção é completa e exata. Então:
 *  1) Texto que descreve categoria (+ gênero + tipo de manga + "em estoque") vai direto
 *     para a coleção certa com os filtros aplicados.
 *     Ex.: "conjunto manga longa menina" → /collections/conjuntos-menina?filtro Manga Longa
 *  2) Senão, busca exigindo TODAS as palavras no nome (title:palavra), mantendo o tipo de
 *     manga como filtro. Se não achar nada, volta sozinha para a busca normal.
 * O texto digitado continua aparecendo no campo de busca.
 */
(function () {
  'use strict';

  var SEM_ACENTO = function (t) {
    return t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  };

  var GENERO = {
    menina: 'menina', meninas: 'menina', feminino: 'menina', feminina: 'menina', girl: 'menina', garota: 'menina',
    menino: 'menino', meninos: 'menino', masculino: 'menino', masculina: 'menino', boy: 'menino', garoto: 'menino',
    unissex: 'unissex', unisex: 'unissex'
  };

  // id do valor do filtro Gênero (Search & Discovery)
  var GENERO_FILTRO = { menina: '132776215', menino: '132808983', unissex: '163381527' };

  // palavra → coleção da categoria (todas abaixo de 5 mil, com filtros).
  // O gênero vira filtro; só onde existe coleção própria por gênero ela é usada.
  var CATEGORIA = {
    conjunto: { c: 'conjuntos' }, conjuntos: 'conjunto',
    vestido: { c: 'vestidos-infantis', sem_filtro: true }, vestidos: 'vestido',
    blusa: { c: 'blusas-e-camisetas' }, blusas: 'blusa', camiseta: 'blusa', camisetas: 'blusa', camisa: 'blusa', camisas: 'blusa', bata: 'blusa', regatas: 'blusa',
    short: { c: 'shorts-e-bermudas' }, shorts: 'short', bermuda: 'short', bermudas: 'short',
    saia: { c: 'saia', sem_filtro: true }, saias: 'saia',
    calca: { c: 'calcas' }, calcas: 'calca', legging: 'calca', leggings: 'calca',
    macacao: { c: 'macacoes-e-jardineiras' }, macacoes: 'macacao', macaquinho: 'macacao', jardineira: 'macacao', jardineiras: 'macacao', romper: 'macacao', salopete: 'macacao',
    casaco: { c: 'casacos-e-jaquetas' }, casacos: 'casaco', jaqueta: 'casaco', jaquetas: 'casaco', moletom: 'casaco', blusao: 'casaco', sueter: 'casaco', colete: 'casaco', cardigan: 'casaco', inverno: 'casaco',
    pijama: { c: 'pijamas' }, pijamas: 'pijama', camisola: 'pijama',
    body: { c: 'bodies' }, bodies: 'body', bory: 'body', bodie: 'body',
    calcinha: { c: 'calcinhas-e-cuecas' }, calcinhas: 'calcinha', cueca: 'calcinha', cuecas: 'calcinha',
    praia: { c: 'moda-praia' },
    biquini: { c: 'biquini', sem_filtro: true }, biquinis: 'biquini',
    maio: { c: 'maio', sem_filtro: true }, maios: 'maio',
    sunga: { c: 'sunga-praia', sem_filtro: true }, sungas: 'sunga',
    tenis: { c: 'tenis' },
    sapato: { c: 'sapatos-e-sapatilhas' }, sapatos: 'sapato', sapatilha: 'sapato', sapatilhas: 'sapato', mocassim: 'sapato',
    bota: { c: 'botas' }, botas: 'bota', botinha: 'bota', botinhas: 'bota', coturno: 'bota', coturnos: 'bota',
    junino: { c: 'festa-junina' }, junina: 'junino', juninos: 'junino', juninas: 'junino', caipira: 'junino', arraia: 'junino', quadrilha: 'junino',
    natal: { c: 'natal' }, natalino: 'natal', natalina: 'natal', natalinos: 'natal', natalinas: 'natal',
    sandalia: { c: 'sandalias-e-chinelos' }, sandalias: 'sandalia', chinelo: 'sandalia', chinelos: 'sandalia', papete: 'sandalia', papetes: 'sandalia',
    meia: { c: 'meias' }, meias: 'meia',
    calcado: { c: 'calcados' }, calcados: 'calcado',
    batizado: { c: 'batizado', genero: { menina: 'batizado-menina', menino: 'batizado-menino' } },
    fantasia: { c: 'fantasias-1' }, fantasias: 'fantasia',
    bale: { c: 'bale-ballet', sem_filtro: true }, ballet: 'bale', bailarina: 'bale',
    acessorio: { c: 'acessorios', sem_filtro: true }, acessorios: 'acessorio'
  };

  // expressões que viram filtro da coleção/busca
  var ATRIBUTOS = [
    { termo: 'manga longa', param: 'filter.p.m.custom.tipodemanga', valor: 'Manga Longa' },
    { termo: 'manga comprida', param: 'filter.p.m.custom.tipodemanga', valor: 'Manga Longa' },
    { termo: 'manga curta', param: 'filter.p.m.custom.tipodemanga', valor: 'Manga Curta' },
    { termo: 'regata', param: 'filter.p.m.custom.tipodemanga', valor: 'Regata' },
    { termo: 'em estoque', param: 'filter.v.availability', valor: '1' },
    { termo: 'disponivel', param: 'filter.v.availability', valor: '1' },
    { termo: 'moda praia', param: null, valor: null, vira: 'praia' },
    { termo: 'festa junina', param: null, valor: null, vira: 'junino' },
    { termo: 'sao joao', param: null, valor: null, vira: 'junino' },
    { termo: 'look junino', param: null, valor: null, vira: 'junino' }
  ];


  // Marcas (fornecedor do produto). Buscar pela marca usa vendor:, que junta variações
  // como "Reserva" e "Reserva Mini". As que também são palavras comuns só valem se forem
  // a busca inteira.
  var MARCAS = ['alakazoo', 'alenice', 'alphabeto', 'angero', 'anjos baby', 'atual boys', 'babo uabu', 'babyhistory', 'bakulele', 'bambollina',
    'barbara kids', 'beaba', 'bee loop', 'belanora', 'beli me', 'bibi', 'bicho bagunca', 'bimbi', 'biogas', 'blue infantis', 'boy joy', 'braziline',
    'caracoles', 'cattai', 'charpey', 'cinti', 'coloritta', 'colore', 'crep', 'divertto', 'duck way', 'dudes', 'dyan', 'elian', 'fabril lepper',
    'fakini', 'fofope', 'forfun', 'gabriela aquarela', 'gambo', 'glinny', 'grendene', 'grow up', 'hapier', 'have fun', 'herley', 'iaze', 'infanti',
    'jaca lele', 'jet kids', 'johnny fox', 'keko', 'keto baby', 'kifanti', 'kiki xodo', 'king joe', 'kippos', 'kopela', 'kukie', 'kyly', 'le bhua',
    'libelinha', 'lika nene', 'lilimoon', 'lu e lua', 'luc boo', 'lugui', 'luluzinha', 'lumilu', 'lupo', 'malagah', 'maluzinha', 'marisol',
    'marujos e sereias', 'melissa', 'milon', 'mini bear', 'mini lady', 'mini lord', 'molekinha', 'molekinho', 'momi', 'mon bell', 'mon sucre',
    'mx 72', 'nanai', 'nina go', 'nini e bambini', 'ogochi', 'ok friends', 'onda marinha', 'ortofino', 'ortope', 'pakita', 'panda pool',
    'petit cherie', 'pibiti', 'pimpolho', 'pituchinhus', 'priscila moises', 'prolife', 'puket', 'pulla bulla', 'pupila', 'quimby', 'ralakids',
    'rebekids', 'reserva', 'rocicle', 'rovitex', 'salamina', 'somnii', 'the mini forest', 'tip top', 'tom ery', 'trick nick', 'tututi',
    'unipasso', 'up baby', 'vic vicky', 'xua xua', 'youccie'];
  var MARCAS_SO_SOZINHAS = ['diversao', 'serena', 'siri', 'buba', 'dila', 'dok', 'nino', 'kiki', 'hug', 'jump', 'gloss', 'precoce', 'riches',
    'evidence', 'noruega', 'peixote', 'veggi', 'pupi', 'digi', 'dame', 'catavento', 'paraiso', 'play ground', 'playground', 'sonho magico'];
  var APELIDOS = { 'petit': 'petit cherie', 'petit cheri': 'petit cherie', 'petit sherie': 'petit cherie', 'mini melissa': 'melissa', 'reserva mini': 'reserva', 'barbara': 'barbara kids', 'kiki xodo': 'kiki xodo', 'priscila': 'priscila moises', 'luc': 'luc boo', 'xuaxua': 'xua xua' };
  MARCAS.sort(function (a, b) { return b.length - a.length; });

  var IGNORAR = { de: 1, da: 1, do: 1, das: 1, dos: 1, com: 1, e: 1, para: 1, pra: 1, p: 1, infantil: 1, infantis: 1, kids: 1, kid: 1, roupa: 1, roupas: 1, crianca: 1, criancas: 1, a: 1, o: 1, um: 1, uma: 1 };

  function resolverCategoria(palavra) {
    var c = CATEGORIA[palavra];
    if (typeof c === 'string') c = CATEGORIA[c];
    return c || null;
  }

  function planejar(textoOriginal) {
    var texto = ' ' + SEM_ACENTO(textoOriginal).replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
    var filtros = [];
    ATRIBUTOS.forEach(function (a) {
      var alvo = ' ' + a.termo + ' ';
      if (texto.indexOf(alvo) !== -1) {
        texto = texto.replace(alvo, a.vira ? ' ' + a.vira + ' ' : ' ');
        if (a.param && !filtros.some(function (f) { return f[0] === a.param; })) filtros.push([a.param, a.valor]);
      }
    });

    // código/referência numérica: deixa a busca normal do Shopify (procura em SKU e código)
    if (/^\s*\d{3,}\s*$/.test(texto) || ehCodigo(textoOriginal)) return null;

    var marca = null;
    var limpo = texto.trim();
    if (MARCAS_SO_SOZINHAS.indexOf(limpo) !== -1 || MARCAS.indexOf(limpo) !== -1) {
      marca = limpo; texto = ' ';
    } else {
      Object.keys(APELIDOS).sort(function (a, b) { return b.length - a.length; }).some(function (ap) {
        var alvoA = ' ' + ap + ' ';
        if (texto.indexOf(alvoA) !== -1) { marca = APELIDOS[ap]; texto = texto.replace(alvoA, ' '); return true; }
        return false;
      });
      for (var m = 0; !marca && m < MARCAS.length; m++) {
        var alvoM = ' ' + MARCAS[m] + ' ';
        if (texto.indexOf(alvoM) !== -1) { marca = MARCAS[m]; texto = texto.replace(alvoM, ' '); break; }
      }
    }

    var palavras = texto.trim().split(' ').filter(Boolean);

    // palavra digitada pela metade e enviada ("ves", "conj", "sapa"): completa se só houver um destino
    if (!marca && palavras.length === 1 && palavras[0].length >= 3 && !CATEGORIA[palavras[0]] && !GENERO[palavras[0]]) {
      var destinos = {};
      Object.keys(CATEGORIA).forEach(function (k) {
        if (k.indexOf(palavras[0]) === 0) { var r = resolverCategoria(k); if (r) destinos[r.c] = k; }
      });
      var chaves = Object.keys(destinos);
      if (chaves.length === 1) palavras = [destinos[chaves[0]]];
    }

    if (marca) {
      var resto = palavras.filter(function (p) { return !IGNORAR[p]; });
      var g = null;
      resto = resto.filter(function (p) { if (GENERO[p]) { g = g || GENERO[p]; return false; } return true; });
      if (g) filtros.unshift(['filter.p.m.google.gender', 'gid://shopify/FilterSettingGroup/' + GENERO_FILTRO[g]]);
      return { tipo: 'marca', marca: marca, termos: resto, filtros: filtros };
    }
    var genero = null, categoria = null, sobra = [];
    // ocasião (festa junina, Natal) vale mais que o tipo de peça: "vestido junino" → coleção junina
    var OCASIOES = { 'festa-junina': 1, 'natal': 1 };
    palavras.forEach(function (p) {
      var c = resolverCategoria(p);
      if (c && OCASIOES[c.c]) categoria = c;
    });
    var ocasiao = categoria;
    palavras.forEach(function (p) {
      if (GENERO[p]) { genero = genero || GENERO[p]; return; }
      var c = resolverCategoria(p);
      if (c && ocasiao) return;
      if (c && !categoria) { categoria = c; return; }
      if (IGNORAR[p]) return;
      sobra.push(p);
    });

    if (sobra.length === 0 && (categoria || genero)) {
      if (!categoria) {
        // só o gênero ("menina", "menino")
        return { tipo: 'colecao', colecao: genero === 'menina' ? 'roupas-para-menina' : 'tudo-para-menino', filtros: filtros };
      }
      var colecao = categoria.c;
      if (genero && categoria.genero && categoria.genero[genero]) {
        colecao = categoria.genero[genero];
      } else if (genero && !categoria.sem_filtro) {
        filtros.unshift(['filter.p.m.google.gender', 'gid://shopify/FilterSettingGroup/' + GENERO_FILTRO[genero]]);
      }
      return { tipo: 'colecao', colecao: colecao, filtros: filtros };
    }

    // busca exigindo todas as palavras no nome (palavras originais, sem as que viraram filtro)
    var exigidas = palavras.filter(function (p) { return !IGNORAR[p]; });
    if (exigidas.length === 0) return null;
    return { tipo: 'busca', termos: exigidas, filtros: filtros };
  }


  // Código de produto (SKU como 2610-C315301-1A/12A ou código de barras): não passa pelo roteador.
  // Se só um produto tiver esse código, abre direto a página dele, já na variação certa.
  function ehCodigo(t) {
    t = (t || '').trim();
    if (/\s/.test(t)) return false;
    return /^\d{3,}$/.test(t) || (/\d/.test(t) && /^[A-Za-z0-9]+([-\/._][A-Za-z0-9]+)+$/.test(t));
  }

  function irParaCodigo(codigo) {
    var normal = '/search?' + new URLSearchParams({ q: codigo, type: 'product', lbq: codigo, lbfb: '1' }).toString();
    var u = '/search/suggest.json?' + new URLSearchParams({ q: codigo, 'resources[type]': 'product', 'resources[limit]': '2' }).toString();
    return fetch(u, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
        if (ps.length !== 1) return normal;
        var base = ps[0].url.split('?')[0];
        return fetch(base + '.js').then(function (r) { return r.json(); }).then(function (p) {
          var alvo = codigo.toUpperCase();
          var v = (p.variants || []).filter(function (x) { return (x.sku || '').toUpperCase() === alvo || (x.barcode || '').toUpperCase() === alvo; })[0];
          return v ? base + '?variant=' + v.id : base;
        }).catch(function () { return base; });
      })
      .catch(function () { return normal; });
  }

  function montarUrl(plano, original) {
    var params = new URLSearchParams();
    if (plano.tipo === 'colecao') {
      params.set('filter.v.availability', '1');
      params.set('sort_by', 'created-descending');
      plano.filtros.forEach(function (f) { if (!params.has(f[0])) params.append(f[0], f[1]); });
      params.set('lbq', original);
      return '/collections/' + plano.colecao + '?' + params.toString();
    }
    if (plano.tipo === 'marca') {
      var q = 'vendor:"' + plano.marca + '"';
      if (plano.termos.length) q += ' ' + plano.termos.map(function (t) { return 'title:' + t; }).join(' ');
      params.set('q', q);
      params.set('type', 'product');
      plano.filtros.forEach(function (f) { params.append(f[0], f[1]); });
      params.set('lbq', original);
      return '/search?' + params.toString();
    }
    params.set('q', plano.termos.map(function (t) { return 'title:' + t; }).join(' '));
    params.set('type', 'product');
    plano.filtros.forEach(function (f) { params.append(f[0], f[1]); });
    params.set('lbq', original);
    return '/search?' + params.toString();
  }

  function rotear(original) {
    if (!original || !original.trim()) return null;
    var plano = planejar(original);
    return plano ? montarUrl(plano, original.trim()) : null;
  }

  // Envio do formulário de busca (cabeçalho, página de busca, predictive search)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var acao = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/search\/?$/.test(acao)) return;
    var campo = form.querySelector('input[name="q"]');
    if (!campo) return;
    if (ehCodigo(campo.value)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      irParaCodigo(campo.value.trim()).then(function (url) { window.location.href = url; });
      return;
    }
    var destino = rotear(campo.value);
    if (!destino) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = destino;
  }, true);

  // Link "ver todos os resultados" da busca preditiva
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="/search?"]');
    if (!link || link.closest('.lb-busca-livre')) return;
    try {
      var u = new URL(link.href, location.origin);
      if (u.searchParams.has('lbq') || u.searchParams.has('lbfb')) return;
      var q = u.searchParams.get('q');
      if (!q || /^title:/.test(q)) return;
      var destino = rotear(q);
      if (!destino) return;
      e.preventDefault();
      window.location.href = destino;
    } catch (err) { /* segue o link normal */ }
  }, true);

  // Na página de destino: mostra o que a cliente digitou e garante que nunca fica vazio
  function aoCarregar() {
    var params = new URLSearchParams(location.search);
    // chegou na pesquisa sem passar pelo roteador (ex.: Enter na busca rápida): roteia agora
    if (location.pathname.indexOf('/search') === 0 && !params.get('lbq') && !params.get('lbfb')) {
      var qBruto = params.get('q');
      if (qBruto && ehCodigo(qBruto)) {
        irParaCodigo(qBruto.trim()).then(function (url) { if (url.indexOf('/search?') !== 0) location.replace(url); });
        return;
      }
      if (qBruto && !/(title|vendor):/i.test(qBruto)) {
        var destino = rotear(qBruto);
        if (destino) { location.replace(destino); return; }
      }
    }
    var original = params.get('lbq');
    if (!original) return;
    document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = original; });

    // títulos da página de busca mostram o texto digitado, não a sintaxe interna (title:/vendor:)
    var interno = /(?:title|vendor):\s*"?[^"\s]+(?:\s[^"\s:]+)*"?/i;
    if (location.pathname.indexOf('/search') === 0) {
      document.title = document.title.replace(/para\s+.*?\s+–/, 'para "' + original + '" –');
      document.querySelectorAll('main h1, main h2, main .search-results__heading, main [class*="search"] p').forEach(function (el) {
        if (/(title|vendor):/i.test(el.textContent)) {
          el.childNodes.forEach(function (n) {
            if (n.nodeType === 3 && /(title|vendor):/i.test(n.textContent)) n.textContent = n.textContent.replace(/(?:(?:title|vendor):\s*"?[^"]*?"?\s*)+(?=$|[^\w"])/gi, '"' + original + '"');
          });
          if (/(title|vendor):/i.test(el.textContent)) el.textContent = el.textContent.replace(/(?:(?:title|vendor):\S+\s*)+/gi, '"' + original + '" ');
        }
      });
    }

    // busca pelo nome é precisa; para quem quer mais, um atalho para a busca ampla (descrição, etiquetas)
    if (location.pathname.indexOf('/search') === 0 && /(title|vendor):/i.test(params.get('q') || '') && !document.querySelector('.lb-busca-livre')) {
      var grade = document.querySelector('main .product-grid, main product-grid, main [class*="product-grid"]');
      if (grade) {
        var amplo = new URLSearchParams({ q: original, type: 'product', lbfb: '1', 'filter.v.availability': '1' });
        var aviso = document.createElement('p');
        aviso.className = 'lb-busca-livre';
        aviso.innerHTML = 'Mostrando peças com <strong>"' + original.replace(/[<>&"]/g, '') + '"</strong> no nome. <a href="/search?' + amplo.toString() + '">Ver busca ampla</a> (inclui descrição e etiquetas).';
        grade.parentNode.insertBefore(aviso, grade);
      }
    }

    if (location.pathname.indexOf('/search') === 0 && !params.get('lbfb')) {
      var semResultado = /\b0 resultados?\b/i.test(document.title) || !document.querySelector('product-card, .product-grid__item');
      if (semResultado) {
        var volta = new URLSearchParams();
        volta.set('q', original);
        volta.set('type', 'product');
        volta.set('lbfb', '1');
        location.replace('/search?' + volta.toString());
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', aoCarregar);
  else aoCarregar();

  window.lbBusca = { planejar: planejar, rotear: rotear, ehCodigo: ehCodigo, irParaCodigo: irParaCodigo };
})();
